import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntIcon } from '../icon/icon.component.js';
import calloutStyles from './callout.css.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntCallout extends CrntElement {
  constructor() {
    super(...arguments);
    this.variant = "informative";
    this._lightDomSlotFallbackController = new LightDomSlotFallbackController(
      this,
      this._lightDomSlotFallbackControllerSlots
    );
  }
  static {
    this.dependencies = {
      [CrntIcon.tagName]: CrntIcon
    };
  }
  static {
    this.styles = trustedCSS(calloutStyles);
  }
  static {
    this.tagName = "crnt-callout";
  }
  get icon() {
    switch (this.variant) {
      case "negative":
        return "triangle-exclamation";
      case "positive":
        return "circle-check";
      default:
        return "info-circle";
    }
  }
  get _lightDomSlotFallbackControllerSlots() {
    return [
      () => ({
        fallbackElement: () => {
          const icon = document.createElement("crnt-icon");
          icon.icon = this.icon;
          icon.square = true;
          return icon;
        },
        override: true,
        slotName: "icon"
      })
    ];
  }
  render() {
    return html`
			<div part="container">
				<div part="icon"><slot name="icon"></slot></div>
				<div part="title"><slot name="title"></slot></div>
				<div part="body"><slot></slot></div>
				<div part="actions"><slot name="actions"></slot></div>
			</div>
		`;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (changedProperties.has("variant")) {
      this._lightDomSlotFallbackController.setFallbackSlotsContent();
    }
  }
}
__decorateClass([
  property({ reflect: true })
], CrntCallout.prototype, "variant");

export { CrntCallout };
